<template lang="">
  <div class="text-center" :class="{ 'fixed inset-0 z-50 bg-white': logo }">
    <!-- Logo de Orsai -->
    
    <div class="flex flex-col items-center justify-center h-96">
        <img v-if="logo" src="@/assets/logo.png" alt="Logo de Orsai" class="w-10 h-10 mx-auto mb-4" />
        <div class="animate-pulse ">    
        <div class="bg-gray-200 h-4 w-56 rounded-full mb-4"></div>
            <div class="bg-gray-200 h-4 w-56 rounded-full mb-4"></div>
            <div class="bg-gray-200 h-4 w-56 rounded-full mb-4"></div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Cargando",
    props: {
        logo: {
            type: Boolean,
            default: false,
        },
    },
};
</script>